export const filterAndCleanCategories = (categories, filterKey = '[valuefinds]') => {
    if (!categories || !Array.isArray(categories)) {
        return [];
    }

    return categories
        .filter(category => category.name && category.name.includes(filterKey))
        .map(category => {
            // Remove the filter key
            let cleanedName = category.name.replace(filterKey, '').trim();
            
            // Remove the leading dash if it exists (e.g., if the format was "[key] - Name")
            if (cleanedName.startsWith('-')) {
                cleanedName = cleanedName.substring(1).trim();
            }

            return {
                ...category,
                name: cleanedName
            };
        });
};
